const excludeFields = [
  "acl",
  "question1",
  "qu",
  "question2",
  "question3",
  "question4",
  "question5",
  "question6",
  "question7",
  "question8",
  "question9",
  "question10",
  "question11",
  "question12",
  "recruiter",
];

export default excludeFields;
